import { SET_USER_SETTINGS } from "./saveSettingAction";


export const setUserSettings = (userSettings) => (
    {
        type: SET_USER_SETTINGS,
        payload: userSettings,
    }
);